'use client';
import React, { useState } from 'react';
import { Accordion, AccordionDetails, AccordionSummary, Button, Typography } from '@mui/material';
import { ExpandMore } from '@mui/icons-material';
import { EventBus } from '@/shared/utils';
import { ProfileEvents, ProfileEventKeys } from '../../events';
import { Profile } from '@/shared/i18n';
import { Profile as ProfileType } from '../../types/profile';
import DeleteAccountDialog from './delete-account-dialog';

interface DeleteAccountProps {
  eventBus: EventBus<ProfileEvents>;
  dict: Profile['profile'];
  profile: ProfileType;
}

const DeleteAccount: React.FC<DeleteAccountProps> = ({ eventBus, dict, profile }) => {
  const [expanded, setExpanded] = useState<string | false>(false); // Manage accordion state
  const [openDialog, setOpenDialog] = useState(false); // State to manage dialog visibility

  // Handlers to open and close the dialog
  // Handler for accordion change
  const handleAccordionChange =
    (panel: string) => (_: React.SyntheticEvent, isExpanded: boolean) => {
      setExpanded(isExpanded ? panel : false);
    };

  // Handlers to open and close the dialog
  const handleOpenDialog = () => setOpenDialog(true);

  return (
    <>
      <Accordion
        expanded={expanded === 'panel1'}
        onChange={handleAccordionChange('panel1')}
        className="w-full rounded-xl border-none"
      >
        <AccordionSummary
          expandIcon={<ExpandMore color="primary" />}
          aria-controls="panel1-content"
          id="panel1-header"
          className="py-2 px-6"
        >
          <Typography variant="h5" fontWeight="bold" color="textSecondary">
            {dict.account_title}
          </Typography>
        </AccordionSummary>
        <AccordionDetails className="px-6 pb-6">
          <Typography variant="body2" component="p" className="mb-2">
            {dict.account_delete_description}
          </Typography>
          <Button variant="outlined" color="error" onClick={handleOpenDialog}>
            <Typography variant="button-l">{dict.account_delete_btn_txt}</Typography>
          </Button>
        </AccordionDetails>
      </Accordion>

      <DeleteAccountDialog
        dict={dict}
        isOpen={openDialog}
        onSubmit={() => eventBus.emit(ProfileEventKeys.profile.delete, profile)}
        onClose={() => setOpenDialog(false)}
      />
    </>
  );
};

export default DeleteAccount;
